<!-- ============================================================== -->
<!-- toggle and nav items -->
<!-- ============================================================== -->
<!-- <ul class="navbar-nav float-start me-auto">
  <li class="nav-item">
    <a class="nav-link waves-effect waves-dark" href="/dashboard"> Starter </a>
  </li>
  <li class="nav-item">
    <a class="nav-link waves-effect waves-dark" href="/about"> About </a>
  </li> -->
  <!-- ============================================================== -->
  <!-- create new -->
  <!-- ============================================================== -->
  <!-- <li class="nav-item d-none d-md-block" ngbDropdown placement="bottom-end">
    <a
      ngbDropdownToggle
      class="nav-link waves-effect waves-dark"
      href="javascript:void(0)"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    > -->
      <!-- <span>Create New</span>
    </a>
    <div ngbDropdownMenu>
      <a class="dropdown-item" href="#">Action</a>
      <a class="dropdown-item" href="#">Another action</a>
      <div class="dropdown-divider"></div>
      <a class="dropdown-item" href="#">Something else here</a>
    </div>
  </li>
</ul> -->
<!-- ============================================================== -->
<!-- Right side toggle and nav items -->
<!-- ============================================================== -->
<ul class="navbar-nav float-end">
  <!-- ============================================================== -->
  <!-- User profile and search -->
  <!-- ============================================================== -->
  <li class="nav-item" ngbDropdown placement="bottom-end">
    <a
      ngbDropdownToggle
      class="nav-link waves-effect waves-dark pro-pic"
      href="javascript:void(0)"
      data-toggle="dropdown"
      aria-haspopup="true"
      aria-expanded="false"
    >
      <img
        src="assets/images/users/user1.jpg"
        alt="user"
        class="rounded-circle"
        width="31"
      />
      <span class="ms-2">Admin</span>
    </a>
    <div class="dropdown-menu-right" ngbDropdownMenu>
      
      <a class="dropdown-item" href="javascript:void(0)" (click)="logout()">
        <i class="fa fa-power-off m-r-5 m-l-5"></i> Logout</a
      >
    </div>
  </li>
  <!-- ============================================================== -->
  <!-- User profile and search -->
  <!-- ============================================================== -->
</ul>
